import React from 'react';

const ProcessSection = () => {
  return (
    <section className="process-section pt-0">
      <span className="wide-map"></span>
      <div className="anim-icons">
        <span className="icon icon-object-1"></span>
      </div>
      <div className="auto-container">
        <div className="sec-title text-center">
          <span className="sub-title">Our work process</span>
          <h2>Get your Visa Approved in <br />3 Simple Steps.</h2>
        </div>
        <div className="row">

          {/* Process Block 1 */}
          <div className="process-block col-lg-4 col-md-6 col-sm-12 wow fadeInUp">
            <div className="inner-box">
              <div className="image-box">
                <figure className="image">
                  <img src="/assets/images/resource/process-1.jpg" alt="Process 1" />
                </figure>
                <span className="count">01</span>
              </div>
              <div className="info-box">
                <h6 className="title">
                  <a href="page-service-details.html">Online Formu Doldurun</a>
                </h6>
                <div className="text">
                  Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.
                </div>
              </div>
            </div>
          </div>

          {/* Process Block 2 */}
          <div className="process-block col-lg-4 col-md-6 col-sm-12 wow fadeInUp" data-wow-delay="400ms">
            <div className="inner-box">
              <div className="image-box">
                <figure className="image">
                  <img src="/assets/images/resource/process-2.jpg" alt="Process 2" />
                </figure>
                <span className="count">02</span>
              </div>
              <div className="info-box">
                <h6 className="title">
                  <a href="page-service-details.html">Belgeler ve Ödemeler</a>
                </h6>
                <div className="text">
                  Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.
                </div>
              </div>
            </div>
          </div>

          {/* Process Block 3 */}
          <div className="process-block col-lg-4 col-md-6 col-sm-12 wow fadeInUp" data-wow-delay="800ms">
            <div className="inner-box">
              <div className="image-box">
                <figure className="image">
                  <img src="/assets/images/resource/process-3.jpg" alt="Process 3" />
                </figure>
                <span className="count">03</span>
              </div>
              <div className="info-box">
                <h6 className="title">
                  <a href="page-service-details.html">Vizenizi Alın</a>
                </h6>
                <div className="text">
                  Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ProcessSection;